import {useTranslation} from "react-i18next";
import FormFieldBox from "../../common/form/FormFieldBox";
import FormRow from "../../common/form/FormRow";
import React, {useMemo} from "react";
import {Control} from "react-hook-form";
import TextInput from "../../common/form/TextInput";
import {allowedTools} from "../UserForm";

type Props = {
    index: number
    control: Control<any>
}


export const AllowedToolsForm = ({ index, control}: Props) => {
    const { t } = useTranslation()

    const allowedToolsOptions = useMemo(
        () =>
            allowedTools.map(tool => {
                return {
                    value: tool.value,
                    label: t(tool.label),
                }
            }),
        [t]
    )

    return (<FormRow>
        <FormFieldBox>
            <FormFieldBox>
                <TextInput
                    label={t('users.edit.allowed-tools')}
                    name={`fieldUpdates.${index}.values.0.stringValues`}
                    control={control}
                    required={false}
                    options={allowedToolsOptions}
                    isCheckbox={true}
                />
            </FormFieldBox>
        </FormFieldBox>
    </FormRow>)
}